module.exports = __webpack_public_path__ + "img/ep-1.4c2328b9.jpeg";